import { Fragebogen } from '../protected/fragebogen/fragebogen.model';
import { Frage } from '../protected/fragebogen/frage.model';
import { Antwort } from '../protected/fragebogen/antwort.model';
export class Session {
  pfad: {
    fragebogen:{
      obj: Fragebogen,
      kinder:{
       frage:{
         obj: Frage,
         kinder:{
           antwort:{
             obj: Antwort
           }
         }
       }
      }
    }
  } = {
    fragebogen:{
      obj: null,
      kinder:{
       frage:{
         obj: null,
         kinder:{
           antwort:{
             obj: null
           }
         }
       }
      }
    }
  }  
}